import { forwardRef, useCallback, useEffect } from 'react';
import { SearchInputProps } from '../types';

const AiSearchInput = forwardRef<HTMLTextAreaElement, SearchInputProps>(
  ({ value, onChange, onFocus, disabled = false, placeholder, className = '' }, ref) => {
    // Auto-resize textarea with max 5 rows
    useEffect(() => {
      if (!ref || typeof ref === 'function') {
        return;
      }

      const textarea = ref.current;
      if (!textarea) {
        return;
      }

      const adjustHeight = () => {
        textarea.style.height = 'auto';
        const scrollHeight = textarea.scrollHeight;
        const lineHeight = 24; // text-base leading-6 = 24px
        const maxHeight = lineHeight * 5; // 5 rows max

        if (scrollHeight <= maxHeight) {
          textarea.style.height = `${scrollHeight}px`;
          textarea.style.overflowY = 'hidden';
        } else {
          textarea.style.height = `${maxHeight}px`;
          textarea.style.overflowY = 'auto';
        }
      };

      adjustHeight();
    }, [value, ref]);

    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
      },
      [onChange]
    );

    return (
      <div className={`relative max-h-[290px] min-h-[68px] flex-1 ${className}`} data-testid="ai-search-input-wrapper">
        <textarea
          data-testid="ai-search-input"
          ref={ref as any}
          value={value}
          onFocus={onFocus}
          disabled={disabled}
          onChange={handleChange}
          className="size-full max-h-[120px] min-h-[68px] resize-none overflow-y-auto border-none bg-slate-50 px-0 py-2 text-base leading-6 text-slate-900 placeholder:font-normal placeholder:text-slate-300 focus:outline-none focus:ring-0"
          placeholder={placeholder}
          rows={2}
        />
      </div>
    );
  }
);

AiSearchInput.displayName = 'AiSearchInput';

export default AiSearchInput;
